import React, {useEffect, useState} from  'react'
import DOMPurify from 'dompurify';
import { formStateStore } from '../../Redux/Store/store';
import { getContainerId } from './IFormDesignerLogic';


 function PrepareCSSClass(props){
  const state=formStateStore.getState();
   let containerId = getContainerId();
  if(containerId===undefined){
    containerId="default"
  }
 let nonceValue= state.data.find(json => json.key === containerId)?.noncevalue;
 
 if(!nonceValue){
    nonceValue = document.querySelector('meta[id="mui-meta"]')?.getAttribute('content');
 }

    var styleString = '' ;

    
    if(props.customCSS===true)
    {
      styleString = props.stylingData;

    }else{

      props.stylingData && Object.keys(props.stylingData).forEach((key)=>{
         
        if(key && props.stylingData[key]){
          var stylingString ="" ;
          Object.keys(props.stylingData[key]).forEach((subKey)=>{
            stylingString = stylingString.concat(subKey + ':' + props.stylingData[key][subKey] + ';');
          })
          styleString = styleString + '.' + key + '{' + stylingString + '}' + '\n';
        }
        
      })
    
   }


    if(styleString){
      return(
        <style dangerouslySetInnerHTML={{__html: `
            ${DOMPurify.sanitize(styleString)} 
        `}} nonce={nonceValue}/>
      )
    }else {
      return(
        <></>   
      )
    }
   
}

export default PrepareCSSClass ;